import LongText from '../Elements/LongText';
import LookupText from '../Elements/LookupText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import React from 'react';
import urlHelper from '../Helpers/urlHelper';
import JsxHelper from '../Helpers/JsxHelper';

export default class OutstandingTpRelatedInvoiceItem {
  constructor(item) {
    if (item === undefined) {
      this.CiId = '';
      this.CiDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.CiCount = '';
      this.CiTotal = '';
      this.CiYrmo = '';
      this.CiInvoiceDueDate = dateTimeHelper.addDaysToDate(dateTimeHelper.toYYYYsMMsDD(new Date()), 45);
      this.CiInternalReferenceNumber = '';
      this.CiBillToContactFirstName = '';
      this.CiBillToContactLastName = '';
      this.CiCurrentTotalDue = '';
      this.CiInvoiceNumber = '';
      this.CiPonumber = '';
      this.CiInvoiceComment = '';
      this.CiStatusCode = '';
      this.CiOfficeId = '';
      this.ClientNameId = '';
      this.OfficeName = '';
      this.CurrencyCode = '';
      this.HasPrepayLines = false;
      this.TotalWithVat = '';
      this.Selected = false;
      return;
    }
    this.CiId = item.ciId;
    this.CiDate = item.ciStatusCode && item.ciStatusCode >= 2 ? item.ciDate : new Date();
    this.CiCount = item.ciCount ? item.ciCount : ' ';
    this.CiTotal = item.ciTotal;
    this.CiYrmo = item.ciYrmo ? item.ciYrmo : ' ';
    this.CiInvoiceDueDate = item.ciInvoiceDueDate;
    this.CiInternalReferenceNumber = item.ciInternalReferenceNumber ? item.ciInternalReferenceNumber : ' ';
    this.CiBillToContactFirstName = item.ciBillToContactFirstName ? item.ciBillToContactFirstName : ' ';
    this.CiBillToContactLastName = item.ciBillToContactLastName ? item.ciBillToContactLastName : ' ';
    this.CiCurrentTotalDue = item.ciCurrentTotalDue ? item.ciCurrentTotalDue : 0;
    this.CiInvoiceNumber = item.ciInvoiceNumber ? item.ciInvoiceNumber : ' ';
    this.CiPonumber = item.ciPonumber ? item.ciPonumber : ' ';
    this.CiInvoiceComment = item.ciInvoiceComment ? item.ciInvoiceComment : ' ';
    this.CiStatusCode = item.ciStatusCode ? item.ciStatusCode : ' ';
    this.CiOfficeId = item.ciOfficeId ? item.ciOfficeId : ' ';
    this.ClientNameId = item.clientNameId;
    this.OfficeName = item.officeName;
    this.CurrencyCode = item.currencyCode;
    this.HasPrepayLines = item.hasPrepayLines;
    this.TotalWithVat = item.totalWithVat ? item.totalWithVat : 0;
    this.Selected = false;
  }

  static MoneyFields = ['CiTotal', 'CiCurrentTotalDue', 'TotalWithVat'];
  static DateFields = ['CiInvoiceDueDate', 'CiDate'];

  static Currency() {
    return 'CurrencyCode';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: OutstandingTpRelatedInvoiceItem.getSelectedCellHeader,
        orderById: '',
        data: OutstandingTpRelatedInvoiceItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Bare Invoice #',
        orderById: 'CiId',
        data: OutstandingTpRelatedInvoiceItem.getDetailCellContent,
        minWidth: 20,
      },
      {
        label: 'Client Name (Caspian Client ID)',
        orderById: 'ClientName',
        data: OutstandingTpRelatedInvoiceItem.getClientNameCellContent,
        minWidth: 50,
      },
      {
        label: 'Bill To Contact',
        orderById: 'CiBillToContact',
        data: OutstandingTpRelatedInvoiceItem.getBillToContactCellContent,
        minWidth: 40,
      },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName', minWidth: 25 },
      {
        label: 'PO #',
        orderById: 'CiPonumber',
        data: OutstandingTpRelatedInvoiceItem.getCPoNumberCellContent,
        minWidth: 20,
      },
      { label: 'Client Invoice #', orderById: 'CiInvoiceNumber', data: 'CiInvoiceNumber', minWidth: 20 },
      {
        label: 'Internal Reference',
        orderById: 'CiInternalReferenceNumber',
        data: OutstandingTpRelatedInvoiceItem.getInternalReferenceCellContent,
        minWidth: 30,
      },
      { label: 'Invoiced On', orderById: 'CiDate', data: 'CiDate', minWidth: 20 },
      { label: 'Due Date', orderById: 'CiInvoiceDueDate', data: 'CiInvoiceDueDate', minWidth: 20 },
      {
        label: 'Status',
        orderById: 'CiStatusCode',
        data: (item) => (
          <LookupText
            lookupId={43}
            value={item.CiStatusCode}
          />
        ),
        minWidth: 20,
      },
      { label: 'Invoice Line #', orderById: 'CiCount', data: 'CiCount', minWidth: 10 },
      {
        label: 'Has Prepay?',
        orderById: 'HasPrepayLines',
        data: (item) => JsxHelper.YesNo(item.HasPrepayLines),
        minWidth: 20,
      },
      { label: 'Total', orderById: 'TotalWithVat', data: 'TotalWithVat', minWidth: 20 },
      { label: 'Current Due', orderById: 'CiCurrentTotalDue', data: 'CiCurrentTotalDue', minWidth: 20 },
      { label: 'YRMO', orderById: 'CiYrmo', data: 'CiYrmo', minWidth: 10 },
    ];
  }

  static getInternalReferenceCellContent(item) {
    return (
      <LongText
        text={item.CiInternalReferenceNumber ? item.CiInternalReferenceNumber : ' '}
        maxLength={25}
      />
    );
  }

  static getBillToContactCellContent(item) {
    return (
      <LongText
        text={`${item.CiBillToContactFirstName} ${item.CiBillToContactLastName}`}
        maxLength={30}
      />
    );
  }

  static getClientNameCellContent(item) {
    return (
      <LongText
        text={item.ClientNameId ? item.ClientNameId : ' '}
        maxLength={40}
      />
    );
  }

  static getCPoNumberCellContent(item) {
    return (
      <LongText
        text={item.CiPonumber ? item.CiPonumber : ' '}
        maxLength={15}
      />
    );
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          OutstandingTpRelatedInvoiceItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={OutstandingTpRelatedInvoiceItem.selectedStatus()}
        onChange={(e) => {
          OutstandingTpRelatedInvoiceItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.CiId,
      '',
      '',
      'clientinvoicedetails',
      `id=${item.CiId}`,
      'Open up in a new tab'
    );
  }
}
